@if (!appSettings.isMobile()) {
  <div class="row mb-3 align-items-end g-2">
    <div class="col-md-5">
      <label class="form-label small text-muted mb-1">Buscar</label>
      <input type="text" class="form-control" placeholder="Título, ruta o audiencia"
        [(ngModel)]="searchText" (ngModelChange)="applyFilters()"
        [disabled]="isEditMode && isSaving">
    </div>
    <div class="col-md-7 d-flex justify-content-end flex-wrap gap-2">
      @if (!isEditMode) {
        @if (canQuickEdit()) {
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="toggleEditMode()">
            <i class="fas fa-edit me-1"></i> Editar
          </button>
        }
        <ng-content></ng-content>
      } @else {
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelEdit()" [disabled]="isSaving">
          <i class="fas fa-times me-1"></i> Cancelar
        </button>
        <button type="button" class="btn btn-primary btn-sm" (click)="saveAll()"
          [disabled]="isSaving || !hasPendingChanges()">
          <i class="fas fa-save me-1"></i> Guardar
        </button>
      }
    </div>
  </div>

  @if (isEditMode) {
    <div class="alert alert-info py-2 small mb-3">
      <i class="fas fa-info-circle me-1"></i>
      Modo edición rápida: activá o desactivá los artículos y luego <strong>Guardar</strong>.
    </div>
  }

  <div class="table-responsive table-data mb-0">
    <table class="table table-hover table-sm align-middle">
      <thead>
        <tr>
          <th>Ruta</th>
          <th>Título</th>
          <th>Audiencia</th>
          <th>Activo</th>
          <th><i class="fas fa-cog"></i></th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading) {
          @for (i of rows; track $index) {
            <tr class="tr-custom">
              @for (c of [1,2,3,4]; track c) {
                <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
              }
            </tr>
          }
        } @else if (filtered.length === 0) {
          <tr>
            <td colspan="5" class="text-muted text-center py-4">No hay artículos de ayuda</td>
          </tr>
        }

        @for (article of filtered; track article.id ?? article.uuid) {
          <tr [class.table-active]="selectedId() === article.id"
              role="button"
              (click)="select(article)">
            <td><code class="small">{{ routeLabel(article.routePath) }}</code></td>
            <td>{{ article.title }}</td>
            <td>
              <span class="badge text-bg-secondary">{{ article.audience || 'Todos' }}</span>
            </td>
            <td (click)="$event.stopPropagation()">
              <div class="form-check form-switch mb-0" title="Activar / desactivar">
                <input class="form-check-input" type="checkbox" role="switch"
                  [checked]="article.isActive !== false"
                  [disabled]="!isEditMode || isSaving"
                  (change)="toggleActive(article, $event)">
              </div>
            </td>
            <td>
              @if (!isEditMode) {
                <div class="btn-group">
                  <button type="button" class="btn btn-xs btn-outline-primary"
                    title="Editar artículo"
                    (click)="select(article); $event.stopPropagation()">
                    <i class="fas fa-pen"></i>
                  </button>
                  @if (canDelete()) {
                    <button type="button" class="btn btn-xs btn-outline-danger"
                      title="Eliminar artículo"
                      (click)="deleteArticle(article); $event.stopPropagation()">
                      <i class="fas fa-trash"></i>
                    </button>
                  }
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
} @else {
  @if (!isEditMode) {
    <app-mobile-footer>
      <input type="search"
        class="form-control mobile-footer-search"
        placeholder="Buscar título, ruta o audiencia..."
        [(ngModel)]="searchText"
        (ngModelChange)="applyFilters()">
      @if (canQuickEdit()) {
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="toggleEditMode()">
          <i class="fas fa-edit me-1"></i>Editar
        </button>
      }
    </app-mobile-footer>
  } @else {
    <app-mobile-footer [visible]="true">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelEdit()" [disabled]="isSaving">
        <i class="fas fa-times me-1"></i>Cancelar
      </button>
      <button type="button" class="btn btn-primary btn-sm flex-grow-1" (click)="saveAll()"
        [disabled]="isSaving || !hasPendingChanges()">
        <i class="fas fa-save me-1"></i>Guardar
      </button>
    </app-mobile-footer>
  }

  <div class="d-flex justify-content-between align-items-center mb-2 px-1">
    <span class="small text-muted fw-bold text-uppercase">
      ARTÍCULOS @if (!isLoading) { ({{ filtered.length }}) }
      @if (isEditMode) { · edición }
    </span>
    @if (!isEditMode) {
      <button type="button" class="btn btn-link btn-sm text-decoration-none p-0"
        (click)="load()" [disabled]="isLoading">
        <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
      </button>
    }
  </div>

  @if (isEditMode) {
    <div class="alert alert-info py-2 small mb-2 mx-1">
      Activá o desactivá y luego Guardar.
    </div>
  }

  <div class="mobile-cards-scroll">
    @if (isLoading) {
      @for (i of rows; track $index) {
        <app-list-card [isLoading]="true"></app-list-card>
      }
    } @else {
      @for (article of filtered; track article.id ?? article.uuid) {
        <app-list-card
          [isShortcut]="!isEditMode"
          (click)="select(article)">
          <div cardTitle class="fw-bold text-dark text-truncate">
            {{ article.title }}
          </div>
          <div cardBadge>
            <span class="badge text-bg-light border">{{ article.audience ||'' }}</span>
          </div>
          <div cardActions (click)="$event.stopPropagation()">
            <div class="d-flex align-items-center gap-2">
              <div class="form-check form-switch mb-0" title="Activar / desactivar">
                <input class="form-check-input" type="checkbox" role="switch"
                  [checked]="article.isActive !== false"
                  [disabled]="!isEditMode || isSaving"
                  (change)="toggleActive(article, $event)">
              </div>
              @if (!isEditMode && canDelete()) {
                <button type="button" class="btn btn-sm btn-outline-danger"
                  title="Eliminar artículo"
                  (click)="deleteArticle(article)">
                  <i class="fas fa-trash"></i>
                </button>
              }
            </div>
          </div>
          <div class="row g-1 text-muted small">
            <div class="col-12">
              <span class="text-muted">Ruta</span>
              <div class="fw-semibold text-dark">
                <code class="small">{{ routeLabel(article.routePath) }}</code>
              </div>
            </div>
          </div>
        </app-list-card>
      }
    }

    @if (!isLoading && filtered.length === 0) {
      <div class="card border-0 shadow-sm p-4 text-center my-2">
        <i class="fas fa-circle-question fa-3x text-muted opacity-50 mb-2"></i>
        <h6 class="text-muted mb-1">Sin artículos</h6>
        <small class="text-muted">Creá uno desde Opciones o ajustá la búsqueda.</small>
      </div>
    }
  </div>
}
